export class PagedData<T> {
    entities: T[];
    recordCount: number;
}


// WEBPACK FOOTER //
// ./src/models/PagedData.tsx